import { render, staticRenderFns } from "./TextSummary.vue?vue&type=template&id=6dc6f0a4&scoped=true"
import script from "./TextSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextSummary.vue?vue&type=style&index=0&id=6dc6f0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc6f0a4",
  null
  
)

export default component.exports